<template>
	<!-- <div> -->
		<vue-apple-login
			mode="logo-only"
			type="sign in"
			color="black"
			:border="false"
			logoSize="medium"
			className="dp_inline"
			:onSuccess="onSuccess"
			:onFailure="onFailure"
		></vue-apple-login>
	<!-- </div> -->
</template>

<script>
    import Axios from 'axios'

    export default {
        data() {
            return {
                signedIn: false,
            }
        },
        methods: {
            onSuccess(data) {
                console.log("data",data);
                // alert("로그인성공");

                let param = {
                    paramUserID : data.userData.sub
                    , paramEmail : data.userData.email
                }
                Axios.post("/youthnavi/signup/apple/login", param).then(function(response) {
                    console.log(response);
                    var rtn = response.data;
                    if(rtn == "/"){
                        location.href = "/";
                    }else if(rtn == "signup"){
                        location.href = "/youthnavi/signup/apple/adult";
                    }
                }).catch(function(ex) {
                    console.log(ex);
                });
            },
            onSuccessLogout(){
                this.signedIn = false;
            },
            onFailure(error) {
                console.log("error",error);
                // alert("로그인실패");
                return false;
            },
        }
    }
</script>